export default "__VITE_ASSET__BCj_e5oj__"